import { useAuth } from '@contexts/auth-provider';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import * as React from 'react';
import { Navigate } from 'react-router-dom';

import type { PublicRouteProps } from './PublicRoute.types';

const PublicRoute = React.memo(
  ({ children }: Readonly<PublicRouteProps>): React.ReactElement => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
      return <AppLoader />;
    }

    if (isAuthenticated) {
      return <Navigate to="/app-initializer" replace />;
    }

    return <>{children}</>;
  }
);

PublicRoute.displayName = 'PublicRoute';

export { PublicRoute };
